import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import { CkeditorConstants } from "../../src/utils";

const {
  htmlElement: { SPAN, PARAGRAPH, DIV, LIST_ITEM, INLINE_IMAGE, IMAGE, FIGURETAG  },
  helperAttributes: { DATA_UNLOCK, SUBTEMPLATE_NAME },
  unLockValues: { no_one },
  suggestionType: { FORMAT_INLINE, INSERTION, DELETION },
  event: { DELETE_FORWARD, DELETE_CONTENT_BACK, BACKSPACE, DELETE, BACKWARD },
  htmlElement: { FIGURE },
  localStorageItem: { RHP_CITATION_REF_CLICK },
} = CkeditorConstants;
export default class InlineSubtemplateFormattingEditing extends Plugin {
  init() {
    const editor = this.editor;
    this.filteredList = null;
    this.suggestionType = null;

    editor.listenTo(
      editor.editing.view.document,
      "keydown",
      (evt, data) => {
        let key = null;

        if (data && data.domEvent && data.domEvent.key) {
          key = data.domEvent.key;
        }

        if (key && ((key === BACKSPACE) || (key === DELETE)) &&
          this.restrictRemoveLastList(key)) {
          this.evtStop(evt, data);
        }
      })

    /**
     * Check if Ctrl + A is pressed or 'Select All' plugin is executed
     */
    let isSelectAll = false;
    const selectAll = this.editor.commands.get('selectAll');
    selectAll.on('execute', () => isSelectAll = true);

    this.listenTo(this.editor.editing.view.document, "delete", (evt, data) => {
      this.rhpCitationRefClicked = JSON.parse(localStorage.getItem(RHP_CITATION_REF_CLICK));
      const anchor = data.document.selection.anchor;
      const selection = this.editor.model.document.selection;
      const currentCursorPosElement = selection.getFirstPosition().parent;
      const { nodeBefore } = currentCursorPosElement;
      const currentSelection = evt.currentTarget.selection;
      const selectedElement =
        currentSelection.anchor.offset === 0 &&
        (currentSelection.getSelectedElement() === null ||
          currentSelection.getSelectedElement().name !== FIGURE);
      const getselectedElement =
        currentSelection.getSelectedElement() === null ||
        currentSelection.getSelectedElement().name !== FIGURE;

      if (
        data.direction === BACKWARD &&
        getselectedElement &&
        (currentCursorPosElement.name === SPAN
        ||
        (currentCursorPosElement.name === INLINE_IMAGE &&
        currentCursorPosElement.parent.hasAttribute(SUBTEMPLATE_NAME)))
      ) {
        this.deleteRemainingSubSection(
          currentCursorPosElement,
          data,
          evt
        );
      }

      if (!isSelectAll && !this.rhpCitationRefClicked && this.restrictRemoveLastParagraph(data) && selection.getSelectedElement()?.name !== FIGURETAG) {
        this.evtStop(evt, data);
      }

      isSelectAll = false;

      // Below logic exclusive for scenarios where <span style=""><strong></strong><span><span>placeholder</span>
      let isValidSpan =
        (anchor.parent && anchor.parent.name === SPAN) ||
        (anchor.parent.parent && anchor.parent.parent.name === SPAN);
      isValidSpan =
        isValidSpan &&
        ((anchor.parent &&
          anchor.parent.previousSibling &&
          anchor.parent.previousSibling.name === SPAN) ||
          (anchor.parent.parent &&
            anchor.parent.parent.previousSibling &&
            anchor.parent.parent.previousSibling.name === SPAN));
      isValidSpan =
        anchor.isAtStart &&
        isValidSpan &&
        ((anchor.parent &&
          anchor.parent.previousSibling &&
          anchor.parent.previousSibling.getStyleNames().includes("color")) ||
          (anchor.parent.parent &&
            anchor.parent.parent.previousSibling &&
            anchor.parent.parent.previousSibling.hasOwnProperty('getStyleNames') &&
            anchor.parent.parent.previousSibling
              .getStyleNames()
              .includes("color")));

      if (isValidSpan) {
        // Checks if user has performed select all action
        let isMultipleTextSelection = false;
        for (const range of selection.getRanges()) {
          const selection = [...range.getWalker()].length;
          if (selection && !isMultipleTextSelection) {
            isMultipleTextSelection = true;
          }
        }
        if (!isMultipleTextSelection) {
          // Restricts deletion of span elements with data-unlock NO-ONE on backspace/delete
          if (
            (anchor.parent &&
              anchor.parent.previousSibling &&
              anchor.parent.previousSibling._attrs &&
              anchor.parent.previousSibling.hasAttribute(DATA_UNLOCK) &&
              anchor.parent.previousSibling.getAttribute(DATA_UNLOCK) ===
                no_one) ||
            (anchor.parent &&
              anchor.parent.parent &&
              anchor.parent.parent.previousSibling &&
              anchor.parent.parent.previousSibling._attrs &&
              anchor.parent.parent.previousSibling.hasAttribute(DATA_UNLOCK) &&
              anchor.parent.parent.previousSibling.getAttribute(DATA_UNLOCK) ===
                no_one)
          ) {
            evt.stop();
            return;
          }
          const element =
            anchor.parent.previousSibling ||
            anchor.parent.parent.previousSibling ||
            null;

          const modelEle =
            this.editor.editing.mapper.toModelElement(element) ||
            this.editor.editing.mapper.toModelElement(element.parent) ||
            null;
          if (element && modelEle) {
            this.moveCursorOnSpanTagStructure(modelEle);
          }
        }

        if (
          selection.getFirstPosition().name === SPAN &&
          selection.getFirstPosition().hasAttribute(SUBTEMPLATE_NAME) &&
          currentCursorPosElement &&
          nodeBefore
        ) {
          this.moveCursorOnSpanTagStructure(nodeBefore);
        }
      } else if (selection.getFirstPosition().parent) {
        /**
         * If backspace is entered and cursor selection is in parent span tag with data-subtemplate-name
         * Then cursor selection will be moved from parent span tag to last child element of the parent span
         */
        const currentCursorPosElement = selection.getFirstPosition().parent;
        const { name } = currentCursorPosElement;
        if (
          currentCursorPosElement.hasAttribute(SUBTEMPLATE_NAME) &&
          name === SPAN &&
          selection.getFirstPosition().nodeBefore &&
          data.direction === "backward"
        ) {
          let cursorPositionEle = selection.getFirstPosition().nodeBefore;
          if (cursorPositionEle.is("text")) {
            cursorPositionEle = cursorPositionEle.previousSibling;
          }
          this.moveCursorOnSpanTagStructure(cursorPositionEle);
        }
      }
    });

    // Listening to enter key event
    this.listenTo(this.editor.editing.view.document, "enter", () => {
      this.filteredList = this.suggestionType = null;

      this.editor.commands.get("enter").on("afterExecute", () => {
        const selectedParentTagName =
          editor.model.document.selection.anchor.parent.name;

        if (selectedParentTagName === PARAGRAPH) {
          const firstPos =
            this.editor.model.document.selection.getFirstPosition();
          const { _attrs } = firstPos.parent;
          const parentAttributesArr = Array.from(_attrs);

          this.editor.model.change((writer) => {
            let removableAttr = [];
            parentAttributesArr.forEach((element) => {
              element[0].includes("selection") &&
                removableAttr.push(element[0]);
            });
            removableAttr.forEach((removeit) => {
              writer.removeSelectionAttribute(
                removeit.split(":")[1],
                firstPos.parent
              );
            });

            writer.removeAttribute("style", firstPos.parent);
          });
        }
      });
    });
  }

  moveCursorOnSpanTagStructure(cursorPositionEle) {
    if (cursorPositionEle) {
      this.editor.model.change((writer) => {
        const newCursorPosition = writer.createPositionAt(
          cursorPositionEle,
          "end"
        );
        writer.setSelection(newCursorPosition);
      });
    }
  }

  createTrackChangeSuggestion(range) {
    if (
      this.editor.commands.get("trackChanges").value &&
      this.editor.plugins.get("TrackChanges").isEnabled
    ) {
      if (this.suggestionType === INSERTION || this.suggestionType === null) {
        this.editor.plugins.get("TrackChangesEditing").markInsertion(range);
      }

      if (this.suggestionType === FORMAT_INLINE) {
        this.editor.plugins.get("TrackChangesEditing").markInlineFormat(range);
      }

      if (this.suggestionType === DELETION) {
        this.editor.plugins.get("TrackChangesEditing").markDeletion(range);
      }
    }
  }

  isCitationOrLink(editor) {
    if (
      editor.model.document.selection.anchor.parent.hasAttribute("class") &&
      editor.model.document.selection.anchor.parent
        .getAttribute("class")
        .includes("ref")
    ) {
      return;
    }
  }

  findSiblingEle(ele, initialArr) {
    // finds next sibling elements to be moved to next line
    if (ele && ele.nextSibling && ele.nextSibling.name !== PARAGRAPH) {
      initialArr.push(ele.nextSibling);
      if (ele.nextSibling.nextSibling) {
        this.findSiblingEle(ele.nextSibling, initialArr);
      }
    }
    return initialArr;
  }

  restrictRemoveLastParagraph(data) {
    const selection = this.editor.model.document.selection;
    const currentCursorPosElement = selection.getFirstPosition().parent;

    return currentCursorPosElement.name === PARAGRAPH &&
      !currentCursorPosElement.hasAttribute("listStyle") &&
      currentCursorPosElement.parent.name === DIV &&
      ((data.domEvent.inputType === DELETE_CONTENT_BACK &&
        selection.anchor.isAtStart) ||
        (data.domEvent.inputType === DELETE_FORWARD &&
          selection.anchor.isAtEnd)) &&
      currentCursorPosElement.parent.childCount === 1;
  }

  restrictRemoveLastList(key) {
    const viewSelection = this.editor.editing.view.document.selection;
    const currentViewElement = viewSelection.getFirstPosition().parent;
    const closestParent = currentViewElement.parent;
    const modelElement = this.editor.model.document.selection.getFirstPosition().parent;

    return closestParent.name === LIST_ITEM &&
      modelElement.parent.name === DIV &&
      ((key === BACKSPACE &&
        viewSelection.anchor.isAtStart) ||
        (key === DELETE &&
          viewSelection.anchor.isAtEnd)) &&
      closestParent.parent.childCount === 1 &&
      modelElement.parent.childCount === 1;
  }

  /**
   * Removes a IST remains, if all characters inside SPAN Tag are deleted and
   * That CurrentCursor Position parent has no other children than element and their parent also will be removed.
   */
  deleteRemainingSubSection(
    currentCursorPosElement,
    data,
    evt
  ) {
    const { _children } = currentCursorPosElement;
    const { _nodes } = _children || {};
    this.editor.model.change((writer) => {
      const selection = this.editor.model.document.selection;
      if (
        currentCursorPosElement.parent &&
        this.minifyNodeCheck(_nodes) &&
        (currentCursorPosElement.parent.hasAttribute(SUBTEMPLATE_NAME) ||
          currentCursorPosElement.hasAttribute(SUBTEMPLATE_NAME))
      ) {
        let range = writer.createRangeOn(currentCursorPosElement);
        if (
          currentCursorPosElement.parent.childCount <= 1 &&
          currentCursorPosElement.parent.name === SPAN
        ) {
          range = writer.createRangeOn(currentCursorPosElement.parent);
        }
        writer.remove(range);
        this.evtStop(evt, data);
      } else if(selection.focus.isAtStart && !this.rhpCitationRefClicked){
        this.evtStop(evt,data);
      }
    });
  }

  /**
   * On Backspace Scenario,
   * Validates the CurrentPosition's children element is text/inline image and it's last character (or) inline element is removing on.
   */
  minifyNodeCheck(_nodes) {
    return (
      _nodes &&
      _nodes.length &&
      (((_nodes[0].is("text") || _nodes[0].is("textProxy")) && _nodes[0]._data.length <= 1) ||
        (_nodes[0].childCount === 0 &&
          _nodes[0].name === IMAGE &&
          _nodes[0].parent.name === INLINE_IMAGE))
    );
  }

  evtStop(evt, data) {
    data.preventDefault();
    evt.stop();
    this.editor.fire("showMessage");
  }
}
